import { ActionIcon, Menu, Text } from "@marketplace/ui";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { MdMoreVert } from "react-icons/md";

import { RouterLink } from "@/components";

import { deleteSalesModalAtom } from "../../atoms";
import type { SalesListItem } from "../../types";

type SalesListTableActionsProps = {
  salesData: SalesListItem;
};

export const SalesListTableActions = ({
  salesData
}: SalesListTableActionsProps) => {
  const { t } = useTranslation("users", {
    keyPrefix: "salesListPage.salesListTable.tableActions"
  });
  const setDeleteSalesModal = useSetAtom(deleteSalesModalAtom);

  const handleDelete = () => {
    try {
      setDeleteSalesModal({
        visible: true,
        data: salesData
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Menu width={120} position="bottom-end">
      <Menu.Target>
        <ActionIcon variant="transparent" className="text-fjord-grey-500">
          <MdMoreVert size={24} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          classNames={{
            item: "!p-0"
          }}
        >
          <RouterLink
            className="p-[14px] block"
            to="/users/sales/$salesId"
            underline="never"
            params={{ salesId: salesData.id }}
          >
            <Text size="s" className="text-fjord-grey-500">
              {t("view")}
            </Text>
          </RouterLink>
        </Menu.Item>
        <Menu.Item onClick={handleDelete}>
          <Text size="s" className="text-fjord-grey-500">
            {t("delete")}
          </Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
